// Room charge (hotel PMS) — the framework-neutral half of the integration.
// The POS half (modal, send flows, UI hooks) lives in
// apps/pos/src/integrations/roomCharge/. "Externally settled receipt" is a
// core concept; this module only supplies the words for a room charge, as the
// settlement presenter registered under the provider's slug.
import { registerSettlementPresenter } from '../../services/SettlementPresenter';
import { I18n } from '../../wrappers/I18n';
import { CustomPaymentTypeLabel } from '../../types';
import { ROOM_CHARGE_PROVIDER } from './constants';
import { roomChargeLabel } from './roomCharge';
export * from './constants';
export * from './roomCharge';
registerSettlementPresenter(ROOM_CHARGE_PROVIDER, {
    paymentLabel: () => I18n.t('integrations.room_charge.room_send_payment'),
    detailLines: order => {
        const label = roomChargeLabel(order);
        return label ? [{ label: I18n.t('integrations.room_charge.room_number'), value: label }] : [];
    },
    // Where the fiscal receipt is, judged by the receipt itself: a never-fiscalized
    // (external) charge is fiscalized by the hotel and collected at the reception;
    // a fiscal receipt settled to a room already went to the guest.
    slipNote: order => I18n.t(order.isExternal()
        ? 'integrations.room_charge.receipt_note'
        : 'integrations.room_charge.receipt_note_settled'),
    // Under the fiscal receipt itself: the receipt is fiscal, so the note only
    // says where the bill went.
    receiptNote: () => I18n.t('integrations.room_charge.fiscal_receipt_note'),
    filterOption: () => ({
        key: CustomPaymentTypeLabel.send_to_room,
        display: I18n.t('integrations.room_charge.room_send_payment'),
    }),
});
//# sourceMappingURL=index.js.map